import { gql } from '@/__generated__';

const UPDATE_SMA_DEVICE_METRIC = gql(`#graphql 
mutation UpdateSmaDeviceMetric($updateSmaDeviceMetricId: Int!, $input: CreateSmaDeviceMetricInput!, $scheduleInput: UpdateSmaScheduleInput) {
  updateSmaDeviceMetric(id: $updateSmaDeviceMetricId, input: $input, scheduleInput: $scheduleInput)
}
`);

export default UPDATE_SMA_DEVICE_METRIC;
